<style>
.vue-daterange-picker .ranges {
  float: right;
  border-left: 1px solid #ddd;
}
.daterangepicker {
  border-left: none !important;
}
.title-page{
  font-size: 2.2rem;
  font-weight: bold;
  display: flex;
}
.reportrange-text{
  border-radius: 10px;
}
.main-content{
  padding: 0px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.trending-name{
  color: #626262;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 1px;
  line-height: 16px;
  text-transform: uppercase;
}
.trending-name .name {
  display: flex;
  align-items: center;
  font-size: 20px;
  line-height: 24px;

}
.trending-name .total-num {
  margin-top: 16px;
  width: 100%;
  color: #008FFB;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
}
.trending-name .sub-num {
  margin-top: 8px;
  color: #656970;
  font-size: 15px;
  font-style: normal;
  font-weight: normal;
  line-height: 16px;
  text-transform: initial;
}
.trending-item{
  display: flex;
  align-items: flex-start;
  cursor: pointer;
}
.grid-trending{
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  column-gap: 16px;
}
.title-trending{
  margin-bottom: 10px;
  font-size: 20px;
  margin-left: 5px;
}
.trending-name:hover {
  color: #064bae;
}
.trending-name:hover .name{
}
.trending-name:hover .total-num {
  color: #064bae;
}
.trending-name:hover .iconNext {
  position: sticky;
  display: inherit;
}
.iconNext{
  display: none;
}
.icon-div{
  height: 29px;
  width: 24px;
}
.name-item{
  display: -webkit-box;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical;
}
</style>
<template>
  <div id="demo-basic-card" class="social" >
    <div class="card-view-trending header-top" >
      <div class="vx-row w-full">
        <div class="vx-col md:w-1/2 w-full mb-2 mt-2">
          <span class="ml-6 title-page">{{$t('managermentTrending.contentTrending')}}</span>
          <label class="text-font ml-6">{{$t('managermentTrending.TrendingsMentionInSocial')}}</label>
        </div>
        <div class="vx-col w-full md:w-1/2 pr-8" style="display: flex;justify-content: flex-end;align-items: center;">
          <div class="ml-8 mt-4" style = "text-align: right;float:right;">
            <span class="text-size">{{$t('title.time')}}:</span>
            <date-range-picker
              class="ml-2"
              ref="picker"
              :locale-data="{format: 'dd/mm/yyyy' }"
              :opens="'left'"
              @update="initScreen"
              v-model="dateRange">
            </date-range-picker>
          </div>
        </div>
      </div>
    </div>
    <div class="card-view-trending">
      <h4 class="ml-6 mt-6 title-page" style="color: #626262">{{$t('managermentTrending.keywordMentions')}}</h4>
      <wordcloud
        style="height: 423px;overflow: hidden"
        :data="defaultWords"
        nameKey="keyword"
        valueKey="value"
        :color="myColors"
        :font="fontWordCloud"
        :showTooltip="showTooltip"
        :rotate="rotate"
        :fontSize="fontSize"
        :wordClick="wordClickHandler"
      >
      </wordcloud>
    </div>
    <div class="title-trending"><span>{{$t('managermentTrending.trendDevelopment')}}</span></div>
    <div class="ml-0 grid-trending mt-8" >
      <div class="trending-item card-view-trending" v-for="(item,index) in dataWords.slice(0,16)" :key="index">
        <div class="main-content">
          <div class="vx-col md:w-1/2 trending-name"  @click="trendingInfo(item,index)">
            <div class="name" style="overflow: hidden;"><span class="name-item">{{item["keyword"]}}</span><div v-if="!item.showWorkChart" class="lds-facebook"><div></div><div></div><div></div></div>
              <div class="icon-div">
                <div class="iconNext">
                  <feather-icon icon="ChevronRightIcon"></feather-icon>
                </div>
              </div>
            </div>
            <div class="total-num">{{item["value"]}}</div>
            <div class="sub-num">{{$t('managermentTrending.contentMentioned')}}</div>
          </div>
          <div class="vx-col md:w-1/2 detail-content" style="height: 130px;">
            <vue-apex-charts
              v-if="item.showWorkChart"
              type=area height="130"
              :options="workChart.chartOptions"
              :series="item.mention"
            >
            </vue-apex-charts>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import wordcloud from 'vue-wordcloud'
import VueApexCharts from 'vue-apexcharts'
import DateRangePicker from '@/layouts/components/vue2-daterange-picker/components/DateRangePicker.vue'
import VueWordCloud from 'vuewordcloud';
import moment from "moment";


export default {
  name: 'app',
  data() {
    return {
      activeWordCloud: false,
      topicId:null,
      topicIdArray:[],
      showWorkChart: false,
      fontWordCloud: "'Spectral SC', serif",
      showTooltip: false,
      fontSize: [20, 80],
      rotate: {from: 0, to: 0, numOfOrientation: 0 },
      dateRange: {
        endDate: new Date(),
        startDate: (() => { let date = new Date ();
          date.setDate(date.getDate() - 6);
          date.setHours(0,0,0);
          return date
        })()
      },
      workChartData: {},
      workChart: {
        series: [],
        chartOptions: {
          chart: {
            offsetX: 0,
            toolbar: {show: false},
            height: 350,
            type: 'area'
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            curve: 'smooth',
            lineCap: 'butt',
            colors: undefined,
            width: 2,
            dashArray: 0,
          },
          markers: {
            size: 0,
          },
          xaxis: {
            tooltip:{
              enabled:false
            },
            categories: [],
            show: false,
            labels: {
              show: false,
            },
            axisBorder: {
              show: false
            },
            axisTicks:  {
              show: false,
            },
            crosshairs: {
              show: false
            }
          },
          grid: {
            show: false,
          },
          fill:{
            opacity: 0.25,
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.6,
              opacityTo: 0.9,
            },
          },
          position: 'back',
          yaxis: {
            show: false,
            labels: {
              show: false
            },
            axisTicks: {
              show: false
            },
            axisBorder: {
              show: false
            },

          },
          tooltip: {
            x: {show: false},
            enabled: true
          },
        }
      } ,
      valueSelect: null,
      myColors:'Paired',
      defaultWords: [
      ],
      dataWords: [
      ],
      topic:null
    }
  },
  components: {
    VuePerfectScrollbar,
    vSelect,
    wordcloud,
    VueApexCharts,
    DateRangePicker,
    VueWordCloud
  },
  computed: {
    validateForm: function () {
      return !this.errors.any();
    },
    timeSelect: {
      get() {
        let object = this.timeOptions.find(el => el.value === this.valueSelect);
        if (!object) {
          return {
            label: this.timeOptions[0].label,
            value: this.timeOptions[0].value
          }
        }
        return {
          label: object.label,
          value: this.valueSelect
        }
      },
      set(val) {
        this.valueSelect = val.value;
      }
    },
  },


  methods: {
    wordClickHandler(name) {
      let topic = this.dataWords.find(item => item.keyword == name);
      let topicName= name;
      let topicId = topic.topicId;
      let startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        endDate = moment(this.dateRange.endDate).format("YYYY-MM-DD");
      this.$router.push(`/user/detail-social-trending?id=${topicId}&name=${topicName}&startDate=${startDate}&endDate=${endDate}`).catch(() => {
      });
    },
    trendingInfo(item){
      let startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        endDate = moment(this.dateRange.endDate).format("YYYY-MM-DD");
      this.$router.push(`/user/detail-social-trending?id=${item.topicId}&name=${item.keyword}&startDate=${startDate}&endDate=${endDate}`).catch(() => {
      });
    },
    dataWordChart: function (){
      this.dataWords.forEach(el => {
        let conditions={
          to: this.to,
          from: this.from,
          topicId: el.topicId
        }
        this.$processor.post("/user-data/get-work-by-day", conditions)
          .then(res => {
            this.workChartData = res.data;
            let mentionByDays = {
              name: this.$t('title.mentioned'),
              data: this.workChartData.mentionByDays.map(x => {
                return x.totalData;
              })
            };
            el.mention = [mentionByDays]
            el.showWorkChart = true
          }).catch(err=>{
          this.$vs.loading.close();
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        })
      })
      // this.activeWordCloud = true;
    },
    getTopicTrending: function(){
      return new Promise((resolve, reject) => {
        this.$vs.loading();
        this.$processor.post(`topic-trending/find-all-trending`,this.dateRange).then(response =>{
          this.defaultWords = response.data.filter(el => el.countData > 0).map(x => {
            let object = {};
            object["keyword"] = x.topicName;
            object["value"] = x.countData;
            object["topicId"] = x.topicId;
            object.showWorkChart = false
            return object;
          });
          this.dataWords = JSON.parse(JSON.stringify(this.defaultWords))
          this.$vs.loading.close();
          resolve();
        }).catch(err=>{
          reject();
          this.$vs.loading.close();
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        })
      })

    },
    initScreen() {
      this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0));
      this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59));
      this.from = this.dateRange.startDate
      this.to = this.dateRange.endDate
      this.getTopicTrending().then(() =>{
        setTimeout(() =>{
          this.dataWordChart(this.dataWords);
        }, 500)
      });
    },
    refreshData: function(){
    },
    optimizedChart: function (data){
      data = data.sort(function(a,b){
        return parseInt(a.stringDate) - parseInt(b.stringDate)
      })
      data.map(item => {
        let date = moment(item.stringDate, 'YYYYMMDD');
        item.month = date.format('Y') + date.format('M');
        item.week = date.week();
        item.day = date.format('D');
        return item;
      })

      let result = [];
      data.reduce(function(res, value) {
        if(data.length <= 21) {
          if (!res[value.day]) {
            res[value.day] = {day: value.day, stringDate: value.stringDate, totalData: 0};
            result.push(res[value.day])
          }
          res[value.day].totalData += value.totalData;
          res[value.day].stringDate += "-D";
          return res;
        }
        if( 14 < data.length && data.length < 62){
          if (!res[value.week]) {
            res[value.week] = {week: value.week, stringDate: value.stringDate, totalData: 0};
            result.push(res[value.week])
          }
          res[value.week].totalData += value.totalData;
          res[value.week].stringDate += "-W";
          return res;
        }
        else if(data.length > 62){
          if (!res[value.month]) {
            res[value.month] = {month: value.month, stringDate: value.stringDate, totalData: 0};
            result.push(res[value.month])
          }
          res[value.month].totalData += value.totalData;
          res[value.month].stringDate += "-M";
          return res;
        }
      }, {});
      data = result;
      return data;

    },
    viewDetailShare(link){
      window.open(link, '_blank');
    }
  },
  async created(){
    this.initScreen();
  }
}
</script>
<style lang="scss" >
.lds-facebook {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  top: -3px;
  float: right;
  padding-left: 25px;
}

.lds-facebook div {
  display: inline-block;
  position: absolute;
  left: 4px;
  width: 3px;
  background: #626262;
  animation: lds-facebook 1.2s cubic-bezier(0, .5, .5, 1) infinite
}

.lds-facebook div:nth-child(1) {
  left: 4px;
  animation-delay: -.24s
}

.lds-facebook div:nth-child(2) {
  left: 10px;
  animation-delay: -.12s
}

.lds-facebook div:nth-child(3) {
  left: 16px;
  animation-delay: 0s;
}

@keyframes lds-facebook {
  0% {
    top: 8px;
    height: 16px
  }

  50%, 100% {
    top: 16px;
    height: 4px
  }
}

#demo-basic-card {
  .card-view-trending {
    background: #fff;
    border-radius: 10px;
    padding: 5px 10px 10px 10px;
    box-shadow: 0px 4px 25px 0px rgba(95, 94, 94, 0.1);
    -webkit-transition: all 0.3s ease-in-out;
    margin-top: -20px;
    margin-bottom: 30px;
  }

  .card-view-trending-xh {
    border-radius: 10px;
    border: 1px solid #ccc;
    padding: 20px;
    box-shadow: 0px 4px 25px 0px rgba(95, 94, 94, 20%);
    margin-bottom: 10px;
  }

  .xh {
    border-bottom: 1px solid #cccccc;
  }
  .wordCloud {
    .text {
      cursor: pointer;
      font-weight: bold;
    }
  }
}
div.tooltip {
  width: 350px ;
  height: 65px ;
}
</style>
